module.exports = __webpack_public_path__ + "static/media/cc.ecc0e321.svg";